(function($, undefined) {
    // profils responsive
    'use strict';
    var slideInPopupBtn;
    var slideInPopupBackBtn;
    var responsiveDetector;
    var desktopActive = true;

    var checkWidth = function() {
        if (responsiveDetector.css('visibility') === 'hidden') {
            if (desktopActive === false) {
                slideInPopupBackBtn.each(function() {
                    $(this).trigger('click');
                });
            }

            desktopActive = true;
        } else {
            desktopActive = false;
        }
    };

    var slideInPopup = function() {
        var t = $(this);
        var popupContentType = t.data('popup');
        var popupCtn = t.closest('.slide-in-popup-outer-ctn').find('.slide-in-popup-ctn');

        popupCtn.find('.slide-in-popup-content[data-popup=' + popupContentType + ']').addClass('selected');
        popupCtn.addClass('slide-in').addClass('open');
        $('body').addClass('no-scroll');
    };

    var slideOutPopup = function() {
        var t = $(this);
        var popup = t.closest('.slide-in-popup-ctn');

        popup.removeClass('slide-in');
        $('body').removeClass('no-scroll');

        setTimeout(function() {
            popup.removeClass('open');
            popup.find('.slide-in-popup-content').each(function() {
                $(this).removeClass('selected');
            });
        }, 300);
    };

    var init = function() {
        slideInPopupBtn = $('.slide-in-popup-btn');
        slideInPopupBackBtn = $('.slide-in-popup-header-ctn');
        responsiveDetector = $('.responsive-detector');

        slideInPopupBtn.click(slideInPopup);
        slideInPopupBackBtn.click(slideOutPopup);

        checkWidth();
        $(window).resize(function() {
            checkWidth();
        });
    };
    
    $(window).on('load',function(){
        init();
    });
    
})(jQuery);
